import { gql } from "@apollo/client";
import { MEMBER_INFO, OPTION_INFO, ROOM_INFO, STAFF_INFO } from "../fragments";

export const CREATE_STAFF = gql`
  mutation createStaff($input: StaffInput!) {
    createStaff(input: $input) {
      ...staffInfo
    }
  }
  ${STAFF_INFO}
`;

export const UPDATE_STAFF = gql`
  mutation updateStaff($input: StaffInput!, $id: ID!) {
    updateStaff(id: $id, input: $input) {
      ...staffInfo
    }
  }
  ${STAFF_INFO}
`;

export const CREATE_MEMBER = gql`
  mutation createMember($input: MemberInput!) {
    createMember(input: $input) {
      ...memberInfo
    }
  }
  ${MEMBER_INFO}
`;

export const UPDATE_MEMBER_ACCOUNT = gql`
  mutation updateMemberAccount($input: UpdateAccountInput!) {
    updateMemberAccount(input: $input) {
      id
      account {
        accountNo
        accountName
        bankName
      }
    }
  }
`;

export const CLEAR_MEMBER_ACCOUNT = gql`
  mutation clearMemberAccount($memberId: ID!) {
    clearMemberAccount(memberId: $memberId) {
      id
      updatedAccount
      account {
        accountNo
        accountName
        bankName
      }
    }
  }
`;

export const ACTIVATE_CRONJOB = gql`
  mutation activateCronjob($status: Boolean!) {
    activateCronjob(status: $status) {
      isEnableCrobJob
    }
  }
`;

export const OPEN_BUG = gql`
  mutation openBug($status: Boolean!) {
    openBug(status: $status) {
      isBugOpen
    }
  }
`;

export const UPDATE_MEMBER_LEVEL = gql`
  mutation updateMemberLevel($member: ID!, $level: Int!) {
    updateMemberLevel(member: $member, level: $level) {
      ...memberInfo
    }
  }
  ${MEMBER_INFO}
`;

export const CREATE_COUNTRY = gql`
  mutation createCountry($input: CountryInput!) {
    createCountry(input: $input) {
      id
      name
      imageUrl
    }
  }
`;

export const UPDATE_COUNTRY = gql`
  mutation updateCountry($id: ID!, $input: CountryInput!) {
    updateCountry(id: $id, input: $input) {
      id
      name
      imageUrl
    }
  }
`;

export const CREATE_ROOM = gql`
  mutation createRoom($input: RoomInput!) {
    createRoom(input: $input) {
      ...roomInfo
    }
  }
  ${ROOM_INFO}
`;

export const UPDATE_ROOM = gql`
  mutation updateRoom($id: ID!, $input: RoomInput!) {
    updateRoom(id: $id, input: $input) {
      ...roomInfo
    }
  }
  ${ROOM_INFO}
`;

export const DELETE_ROOM = gql`
  mutation deleteRoom($id: ID!) {
    deleteRoom(id: $id) {
      ...roomInfo
    }
  }
  ${ROOM_INFO}
`;

export const UPDATE_BOT = gql`
  mutation updateBot($id: ID!, $input: BotInput!) {
    updateBot(id: $id, input: $input) {
      ...memberInfo
    }
  }
  ${MEMBER_INFO}
`;

export const CREATE_OPTION = gql`
  mutation createOption($input: OptionInput!) {
    createOption(input: $input) {
      id
    }
  }
`;

export const UPDATE_OPTION = gql`
  mutation updateOption($id: ID!, $input: OptionInput!) {
    updateOption(id: $id, input: $input) {
      ...optionInfo
    }
  }
  ${OPTION_INFO}
`;

export const DELETE_OPTION = gql`
  mutation deleteRoom($id: ID!, $betOptionId: ID!) {
    deleteOption(id: $id, betOptionId: $betOptionId) {
      ...optionInfo
    }
  }
  ${OPTION_INFO}
`;

export const DELETE_ADMIN = gql`
  mutation deleteAdmin($id: ID!) {
    deleteAdmin(id: $id) {
      id
    }
  }
`;

export const CREATE_ADMIN = gql`
  mutation createAdmin($input: CreateAdminInput!) {
    createAdmin(input: $input) {
      id
    }
  }
`;

export const UPDATE_ADMIN = gql`
  mutation updateAdmin($id: ID!, $input: UpdateAdminInput!) {
    updateAdmin(id: $id, input: $input) {
      id
    }
  }
`;

export const OPEN_ROOM_BUG = gql`
  mutation openRoomBug($isBugOpen: Boolean!, $id: ID!) {
    openRoomBug(isBugOpen: $isBugOpen, id: $id) {
      ...roomInfo
    }
  }
  ${ROOM_INFO}
`;

export const APPROVE_IDENTITY = gql`
  mutation approveMemberIdentity($id: ID!) {
    approveMemberIdentity(id: $id) {
      id
    }
  }
`;

export const RESET_ADMIN_PASSWORD = gql`
  mutation resetAdminPassword($id: ID!, $newPassword: String!) {
    resetAdminPassword(id: $id, newPassword: $newPassword) {
      id
    }
  }
`;

export const GENERATE_NEW_CODE = gql`
  mutation genSecretCode {
    genSecretCode {
      isBugOpen
      isEnableCrobJob
      secretCode
    }
  }
`;
